export function cleanTable() {
    let $body = $(".single-post");
    let $table = $body.find(".content table");
    let $tableStrongTags = $table.find("strong");

    for (let i = 0; i < $tableStrongTags.length; i++) {
        let strong = $($tableStrongTags[i]);
        
        if (strong.text().indexOf("\xa0", 0) !== -1) {
            strong.text(strong.text().trim());
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/cleanTable.js